import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { AGGREGATION_TYPE, BillableMetric, MEASUREMENT_TYPE } from 'src/features/billableMetrics/utils/types';

const RESOURCE = '/subscriptions/billable-metric/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    code?: string;
    measurement_type?: MEASUREMENT_TYPE[];
    aggregation_type?: AGGREGATION_TYPE[];
    is_active?: boolean;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<BillableMetric>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_BILLABLE_METRICS_RESOURCE, useQueryHook as useListBillableMetrics };
